import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

export default function Sessions() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/sessions", { params: { active_only: true } });
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const revoke = async (id) => {
    if (!window.confirm("Revoke this session? The user will be signed out.")) return;
    try { await api.post(`/sessions/${id}/revoke`); toast.success("Session revoked"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sessions-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Active sessions & devices</h1>
        <p className="text-muted-foreground">Every active login across your organization. Revoke any suspicious session immediately.</p>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>User</TableHead>
              <TableHead>IP</TableHead>
              <TableHead>User agent</TableHead>
              <TableHead>Device FP</TableHead>
              <TableHead>MFA</TableHead>
              <TableHead>Started</TableHead>
              <TableHead>Expires</TableHead>
              <TableHead className="text-right">Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((s) => (
              <TableRow key={s.id} data-testid={`session-${s.id}`}>
                <TableCell className="text-sm">{s.user_email}</TableCell>
                <TableCell className="font-mono text-xs">{s.ip || "—"}</TableCell>
                <TableCell className="text-xs max-w-[260px] truncate" title={s.user_agent}>{s.user_agent || "—"}</TableCell>
                <TableCell className="font-mono text-[10px]">{(s.device_fingerprint || "").slice(0, 12)}</TableCell>
                <TableCell>{s.mfa_used ? <Badge>MFA</Badge> : <Badge variant="outline">No</Badge>}</TableCell>
                <TableCell className="font-mono text-[10px]">{new Date(s.created_at).toLocaleString()}</TableCell>
                <TableCell className="font-mono text-[10px]">{new Date(s.expires_at).toLocaleString()}</TableCell>
                <TableCell className="text-right">
                  <Button size="sm" variant="ghost" onClick={() => revoke(s.id)} data-testid={`revoke-session-${s.id}`}>Revoke</Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={8} className="text-center text-muted-foreground py-8">No active sessions.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
